module.exports = __webpack_public_path__ + "static/img/anxun41.f14d678b.png";